import './about.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faBullseye,
  faLightbulb,
  faGraduationCap,
  faUsers,
  faHeart,
  faChartLine
} from "@fortawesome/free-solid-svg-icons";



export const About = () => {
  return (
  

    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">

        <section className='section-about-1'>
            <div>
                <h3 className='align-about-ab'>
  <span className='acasa-about-footer'>Acasa</span>
  <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />

  <span className='color-despre'>Despre</span>
</h3>
            </div>
          
          
        </section>


        <div className='tittle-ab-top'>
            <h4>Despre noi</h4>
        </div>

        

       <section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBullseye} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
  <h4>Misiunea noastra</h4>
  <p>
    Ne propunem sa transformam contabilitatea dintr-un domeniu perceput adesea ca fiind 
    rigid si greu de inteles, intr-o cunoastere clara, logica si accesibila pentru oricine, indiferent de varsta sau nivel de pregatire.
  </p>
  <p>
    Credem ca educatia financiara ar trebui sa fie 
    usor de inteles si utila in viata de zi cu zi, nu o simpla insiruire de reguli de memorat.
  </p>
  <p>
    Prin lectii interactive si exemple practice, facem ca invatarea contabilitatii sa fie 
    mai prietenoasa, mai relevanta si mai eficienta.
  </p>
</div>

</section>


       


         <section className='section-about-2'>
 <div className='part-text-about'>
  <h4>Abordarea noastra</h4>

  <p>
    Noi nu doar predam contabilitate, ci redefinim modul in care oamenii o invata.
  </p>

  <p>
    Fiecare lectie este gandita sa fie interactiva, clara si pas cu pas, astfel incat sa intelegi logica din spatele numerelor, nu doar sa memorezi reguli.
  </p>

  <p>
    Aplicatia noastra se bazeaza pe feedback constant din partea utilizatorilor. 
    Optimizam continutul in mod continuu pentru ca fiecare modul sa ofere rezultate reale si relevante.
  </p>

  <p>
    Cand informatia este prezentata clar si in context practic, conceptele financiare devin nu doar usor de inteles, ci si interesante.
  </p>
</div>


  <div className='part-image-about'>
    <FontAwesomeIcon icon={faLightbulb} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>


     
          <section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faGraduationCap} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
  <h4>Ce iti ofera ContaLearn</h4>
  <ul className='feature-list'>
    <li>🧠 Quizuri interactive care te ajuta sa intelegi conceptele contabile pas cu pas</li>
    <li>🎮 Aplicatii practice si jocuri educative pentru a exersa in mod dinamic</li>
    <li>📚 Lectii vizuale si explicate simplu, usor de parcurs chiar si fara experienta anterioara</li>
    <li>🏢 Exemple din viata reala si situatii concrete din afaceri</li>
    <li>💬 Chat integrat, unde poti lasa comentarii si invata din raspunsurile altora</li>
    <li>📈 Urmarirea progresului si recompense care te motiveaza</li>
    <li>🎓 Diploma digitala la finalul fiecarui curs</li>
  </ul>
</div>

</section>


             <section className='section-about-2'>
                <div className='part-text-about'>
  <h4>Cine sunt cursantii nostri</h4>
  <ul className='feature-list'>
    <li>🎓 Studentii la economie, contabilitate sau business, care isi doresc sa invete practic, nu doar teoretic</li>
    <li>📈 Profesionistii din domeniul financiar-contabil, care vor sa-si actualizeze cunostintele si sa tina pasul cu schimbarile</li>
    <li>💼 Antreprenorii care vor sa inteleaga mai bine finantele propriei afaceri</li>
    <li>🧠 Oricine este curios sa afle "cum functioneaza banii intr-o firma", indiferent de pregatire</li>
  </ul>
  <p>
    Construim ContaLearn pentru cei care nu se multumesc cu teorie vaga, ci isi doresc sa inteleaga cu adevarat conceptele financiare si sa le poata aplica in realitate.
  </p>
</div>

                <div className='part-image-about'>
                    <FontAwesomeIcon icon={faUsers} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
                </div>
                </section>




            <section className='section-about-2'>
            <div className='part-image-about'>
                <FontAwesomeIcon icon={faHeart} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
            </div>
           <div className='part-text-about'>
  <h4>De ce existam</h4>
  <p>
    Pentru ca contabilitatea nu trebuie sa fie grea, plictisitoare sau intimidanta.
  </p>
  <p>
    Credem ca educatia financiara este o superputere – una care ofera incredere, control si libertate.
  </p>
  <p>
    Si toata lumea merita acces la ea.
  </p>
</div>

            </section>

            <section className='section-about-2'>
          <div className='part-text-about'>
  <h4>Imbunatatire continua</h4>
  <p>
    La ContaLearn, ne dedicam constant imbunatatirii. Intrebarile din quizuri si feedback-ul utilizatorilor 
    ne ajuta sa intelegem cum progreseaza cursantii si ce putem face mai bine pentru a le oferi o experienta de invatare cat mai eficienta.
  </p>
  <p>
    Analizam rezultatele pentru a imbunatati lectiile existente si pentru a crea continut nou, mai clar si mai aplicat. 
    Ne actualizam constant materialele pentru ca ele sa reflecte realitatile economice si contabile actuale.
  </p>
  <p>
    Scopul nostru este sa oferim o educatie financiara practica, accesibila si relevanta. 
    La fel ca domeniul financiar, nici noi nu ramanem pe loc.
  </p>
</div>

            <div className='part-image-about'>
                <FontAwesomeIcon icon={faChartLine} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
            </div>
            </section>

             <div className='line-about'></div>

             <section className='section-cta-ab'>
            <div className='cta-text-ab'>
                <h4>Ai intrebari?</h4>
                <p>
                <a href='/contact' className='cta-link-ab'>Contacteaza-ne</a> sau 
                <a href='/blog' className='cta-link-ab'> viziteaza blogul nostru</a> pentru mai multe resurse si raspunsuri.
                </p>
            </div>
            <Link to='../cursuri' className='buton-link-learn-ab'>
                <div className='cta-action-ab'>Incepe sa inveti</div>
            </Link>

            
            </section>








     

      </div>
    </div>
   
  )
}
